import { createSelector } from '@reduxjs/toolkit';

export const getAbout = ()=> {
    return createSelector(
        (state) => state.about_menu,
        (state) => state
    )
}